import base from "@/store/utils/api-route/base";

const customerGlobalAPI = {
	list: `${base.meta}list_konsumen_global`,
	detail: `${base.meta}detail_konsumen_global`,
	topFive: `${base.meta}list_top_5_layanan_snapclean`,
	// export: `${base.konsumen}export_konsumen_global`,
	exportTrack: `${base.konsumen}track_export_konsumen_global`,
	deleteExport: `${base.konsumen}delete_filetemp_konsumen_global`,
	export: {
		job: `${base.export}job`,
		track: `${base.export}track_redis_job`,
		delete: {
			cluster: `${base.export}delete_cluster_redis_job`,
			master: `${base.export}delete_master_redis_job`,
		},
	},
}

export default customerGlobalAPI